
import { Vue } from "vue-class-component";

export default class IncomingOutgoing extends Vue {}
